module.exports = __webpack_public_path__ + "img/icon_plus.068167f6.svg";